module.exports = __webpack_public_path__ + "img/maintenance.c49429ac.svg";